/**
 * product-card.js
 *
 * Consolidates the per-card inline scripts that card-product-design-2.liquid used to emit
 * once per product (the video-modal opener and the window.handleQty quantity stepper).
 * On a collection page that meant ~24 duplicate <script> blocks parsed/executed during
 * load. This single delegated handler replaces all of them with identical behavior.
 *
 * Loaded once, deferred, from layout/theme.liquid.
 */
(function () {
  'use strict';

  // Quantity stepper. Invoked by inline onclick="handleQty(this, 'plus'|'minus')" in the
  // product card markup, so it must stay on window. Defined exactly once here.
  window.handleQty = function (button, action) {
    var container = button.closest('.custom-quantity-selector');
    if (!container) return;
    var input = container.querySelector('.qty-input');
    if (!input) return;
    var value = parseInt(input.value, 10) || 1;
    if (action === 'plus') {
      input.value = value + 1;
    } else if (action === 'minus' && value > 1) {
      input.value = value - 1;
    }
    // Keep notifying any listeners that depend on the quantity (unchanged behavior).
    input.dispatchEvent(new Event('change', { bubbles: true }));
  };

  function closeModal(modal) {
    if (!modal) return;
    var video = modal.querySelector('video');
    modal.style.display = 'none';
    if (video) {
      video.pause();
      video.currentTime = 0;
    }
  }

  // Single delegated click listener for every product-card video modal on the page.
  // Button ids are `video-btn-<section>-<product>` and the matching modal id is
  // `videoModal-<section>-<product>` — mirrors the original per-card logic exactly.
  document.addEventListener('click', function (event) {
    var openBtn = event.target.closest('.video-icon[data-video]');
    if (openBtn && openBtn.id) {
      var modal = document.getElementById(openBtn.id.replace('video-btn-', 'videoModal-'));
      if (modal) {
        var video = modal.querySelector('video');
        var src = openBtn.getAttribute('data-video');
        if (video && video.src !== src) video.src = src;
        modal.style.display = 'flex';
        if (video) {
          var played = video.play();
          if (played && played.catch) played.catch(function () {});
        }
      }
      return;
    }

    var closeBtn = event.target.closest('.video-close');
    if (closeBtn) {
      var modalId = closeBtn.getAttribute('data-modal-id');
      closeModal(modalId ? document.getElementById(modalId) : closeBtn.closest('.video-modal'));
      return;
    }

    // Click on the modal backdrop (the .video-modal element itself) closes it.
    if (event.target.classList && event.target.classList.contains('video-modal')) {
      closeModal(event.target);
    }
  });
})();
